import React, { useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { loginPage } from "../../Redux/Actions/Authentication";
import { connect } from "react-redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import FloatingInput from "../Common/FloatingForm";
export const CompanyImage = (companyId) => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    case 6:
      return require("../../assets/images/Irancell.png");
    default:
      break;
  }
};

export const inquireBill = (
  billId,
  companyId,
  setBillToPay,
  token,
  setLoading,
  period,
  history
) => {
  const URL =
    !period && (companyId === 4 || companyId === 5)
      ? `${urls.Inquire}?bill_company_id=${companyId}&parameter=${billId}&type=now`
      : `${urls.Inquire}?bill_company_id=${companyId}&parameter=${billId}`;
  setLoading(true);
  ApiCall(
    "get",
    URL,
    null,
    "BillInquire",
    token,
    function (e) {
      setLoading(false);
      const data = e.data;

      if (
        data &&
        (data.payment_status === 0 ||
          data.payment_status === null ||
          data.payment_status === undefined)
      ) {
        setBillToPay(data);
        history.push("/billInfo");
      } else if (!data || (data && data.payment_status === 1)) {
        toast.warn(
          "قبض مورد نظر پرداخت شده است. از طریق صفحه سوابق پرداخت می توانید اطلاعات قبض را بررسی کنید",
          {
            position: "bottom-center",
            autoClose: 4500,
            hideProgressBar: true,
            pauseOnHover: false,
          }
        );
      } else {
        toast.warn("قبض مورد نظر پرداخت شده است.", {
          position: "bottom-center",
          autoClose: 4500,
          hideProgressBar: true,
          pauseOnHover: false,
        });
      }
    },
    function (e) {
      setLoading(false);
    }
  );
};

const PeriodBtns = ({ setPeriod }) => {
  const [selected, setSelected] = useState(1);
  return (
    <div className="PeriodBtns">
      <div
        className={selected === 0 ? "selectedPeriod" : null}
        onClick={() => {
          setSelected(0);
          setPeriod(false);
        }}
      >
        میان دوره
      </div>
      <div
        className={selected === 1 ? "selectedPeriod" : null}
        onClick={() => {
          setSelected(1);
          setPeriod(true);
        }}
      >
        پایان دوره
      </div>
    </div>
  );
};

const BillInquire = ({
  value,
  setBillId,
  companyId,
  isLogin,
  loginOpen,
  token,
  loading,
  setLoading,
  history,
  setBillToPay,
}) => {
  const [period, setPeriod] = useState(true);

  const placeholder =
    companyId === 4
      ? "شماره تلفن همراه"
      : companyId === 5
      ? "شماره تلفن ثابت به همراه کد شهر"
      : companyId === 2
      ? "شماره اشتراک گاز"
      : companyId === 3
      ? "شماره اشتراک برق"
      : companyId === 6
      ? "شماره ایرانسل"
      : "شناسه قبض آب";
  return (
    <div className="BillInquire">
      <img src={CompanyImage(companyId)} alt="" id="companyImage" />

      <FloatingInput
        value={value}
        type={"tel"}
        setValue={setBillId}
        labelShort={placeholder}
        label={placeholder}
      />

      {(companyId === 4 || companyId === 5) && (
        <PeriodBtns setPeriod={setPeriod} />
      )}
      {!loading ? (
        <div
          // type="submit"
          className="PayButton"
          style={{ backgroundColor: "#2c3e50" }}
          // value="استعلام"
          onClick={() => {
            if (value.length === 0 && isLogin) {
              toast.warn("شناسه قبض را وارد کنید", {
                position: "bottom-center",
                autoClose: 4500,
                hideProgressBar: true,
                pauseOnHover: false,
              });
            } else {
              isLogin
                ? inquireBill(
                    value,
                    companyId,
                    setBillToPay,
                    token,
                    setLoading,
                    period,
                    history
                  )
                : loginOpen();
            }
          }}
        >
          استعلام
        </div>
      ) : (
        <div className="PayButton" style={{ backgroundColor: "#2c3e50" }}>
          <Loader type="ThreeDots" color="white" height={5} width={20} />
        </div>
      )}
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  loginOpen: () => dispatch(loginPage(true)),
});
const mapStateToProps = (state) => ({
  token: state.auth.token,
});
export default connect(mapStateToProps, mapDispatchToProps)(BillInquire);
